import React, { useEffect, useState, useMemo } from 'react';
import './Footer.css';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import image from '../../Assets/new_image_logo.png'
import LanguageSelector from './LanguageSelector';
import { selectLanguage } from '../../ReduxStore/LanguageSlice';

const languages = [
  { code: 'en', name: 'English' },
  { code: 'hi', name: 'हिन्दी (Hindi)' },
  { code: 'te', name: 'తెలుగు (Telugu)' },
  { code: 'ta', name: 'தமிழ் (Tamil)' },
  { code: 'kn', name: 'ಕನ್ನಡ (Kannada)' },
];

const Footer = () => {
  const { t, i18n } = useTranslation();
  const [isLanguageBtnClicked, setIsLanguageBtnClicked] = useState(false);

  const languageFromStore = useSelector(store => store.LanguageSlice.language);
  const language = useMemo(() => languageFromStore || { code: 'en', name: 'English' }, [languageFromStore]);

  const dispatch = useDispatch();

  const onLanguageChange = (lang) => {
    dispatch(selectLanguage(lang));
    i18n.changeLanguage(lang.code);
    setIsLanguageBtnClicked(false);
  };

  useEffect(() => {
    const storedLanguage = localStorage.getItem('language') || JSON.stringify({ code: 'en', name: 'English' });
    try {
      const parsedLanguage = JSON.parse(storedLanguage);
      dispatch(selectLanguage(parsedLanguage));
      i18n.changeLanguage(parsedLanguage.code);
    } catch (error) {
      console.error('Error parsing language from localStorage:', error);
    }
  }, [dispatch, i18n]);


  const handleCloseOverlay = () => {
    setIsLanguageBtnClicked(false);
  };

  return (
    <footer className="footer">

      <div className="footer-container">
        <div className="footer-logo">
          <img src={image} alt='Company Logo' className='image-logo' />
        </div>
        <div className="footer-links">
          <div className="footer-column">
            <a href="/">{t("Home")}</a>
            <a href="https://instructor.skillzverse.com" target="_blank" rel="noreferrer noopener">
              {t("Instructor")}
            </a>
            {/* <a href="/resume-check">{t("Resume Check")}</a> */}

            <a href="/about">{t("AboutUs")}</a>
            <a href="/contact">{t("ContactUs")}</a>
            <a href="/blog">{t("Blog")}</a>
          </div>
          <div className="footer-column">
            <a href="/terms-conditions">{t("Terms & Conditions")}</a>
            <a href="/privacy-policy">{t("PrivacyPolicy")}</a>
            <a href="/refund-policy">{t("RefundPolicy")}</a>
            <a href="/sitemap">{t("SiteMap")}</a>
          </div>
          <div className="footer-language">
            <button
              className="language-button"
              onClick={() => setIsLanguageBtnClicked(true)}
              aria-label="Language Selector"
            >
              <span className="language-icon">🌐 {language.name}</span>
            </button>
          </div>
        </div>
      </div>

      {isLanguageBtnClicked && (
        <LanguageSelector
          currLanguage={language}
          languages={languages}
          onLanguageChange={onLanguageChange}
          onClose={handleCloseOverlay}
        />
      )}
    </footer>
  );
};

export default Footer;
